import React from "react";
import { observer } from "mobx-react";
import SectionSources from "./SectionSources";

const RenderRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <tr>
      <td>{label}</td>
      <td>{Array.isArray(value) ? value.join(", ") : value}</td>
    </tr>
  );
};

const LeadershipProfile = observer(({ aiInsights, languages, serpLinks }) => {
  if (!aiInsights) return null;

  const {
    count_years_in_leadership_position,
    career_path_summary,
    communication_style,
    known_pain_points,
    strategic_strengths,
    kpi_focus,
    recent_business_challenges,
    community_involvement
  } = aiInsights;

  const hasData = career_path_summary || known_pain_points || strategic_strengths || kpi_focus;
  if (!hasData) return null;

  return (
    <div className="drSection">
      <div className="drSectionHeader">
        <span className="drSectionIcon">🧠</span>
        <h3>Leadership Profile</h3>
      </div>
      <table className="drTable">
        <thead>
          <tr><th>Attribute</th><th>Details</th></tr>
        </thead>
        <tbody>
          {count_years_in_leadership_position && (
            <tr><td>Leadership Tenure</td><td>{count_years_in_leadership_position} years</td></tr>
          )}
          <RenderRow label="Career Path" value={career_path_summary} />
          <RenderRow label="Communication Style" value={communication_style} />
          <RenderRow label="Known Pain Points" value={known_pain_points} />
          <RenderRow label="Strategic Strengths" value={strategic_strengths} />
          <RenderRow label="KPI Focus" value={kpi_focus} />
          <RenderRow label="Challenges Tackled" value={recent_business_challenges} />
          <RenderRow label="Community" value={community_involvement} />
        </tbody>
      </table>
      {languages?.profile_languages?.length > 0 && (
        <div style={{ marginTop: "12px" }}>
          <span style={{ fontSize: "13px", color: "#787878" }}>🗣️ Languages: </span>
          <span style={{ fontSize: "13px", color: "#333" }}>
            {languages.profile_languages.map(l => typeof l === "string" ? l : l.name).join(", ")}
          </span>
        </div>
      )}

      <SectionSources
        serpLinks={serpLinks}
        labels={["PROSPECT_THOUGHT_LEADERSHIP", "PROSPECT_PODCASTS_EVENTS", "PROSPECT_YOUTUBE_TALKS"]}
      />
    </div>
  );
});

export default LeadershipProfile;
